// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Account = /** @class */ (function () {
    // private adapter: Adapter;
    function Account(_props) {
        // this.adapter = props.adapter;
    }
    return Account;
}());
export { Account };
